// Components==============
import Modal from 'components/UI/Modal/Modal';
import { useTranslate } from 'hooks/useTranslate';
import React from 'react';
import './ColorProfileModal.module.scss';
import Colors from 'pages/Growth/GrowthPortfolio/components/Colors/Colors';
import Avatar from 'components/UI/Avatar/Avatar';
import { useMediaQ } from 'hooks/useMediaQ';
// =========================

export default function ColorProfileModal({
  setColorProfileModalIsOpen,
}: {
  setColorProfileModalIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
}) {
  const translate = useTranslate();
  const query = useMediaQ('min', 525);

  return (
    <Modal size="medium" setModalIsOpen={setColorProfileModalIsOpen}>
      <div styleName="modal-content">
        <h1>{translate('reflection.terms.my-color-profile')}</h1>
        <div styleName="colors-wrapper">
          <Colors
            style={{
              position: 'absolute',
              left: '50%',
              top: '50%',
              transform: 'translate(-50%, -50%)',
            }}
          />
          {query && (
            <div
              style={{
                position: 'absolute',
                left: '50%',
                top: '50%',
                transform: 'translate(-50%, -50%)',
              }}
            >
              <Avatar size="huge" border />
            </div>
          )}
        </div>
      </div>
    </Modal>
  );
}
